
import Base from './base'

export default {
  name: 'VsTableSelection',
  extends: Base,
  computed: {
    selected() {
      return this.table.selectedSize
    },
    checked() {
      return this.table.hasData && this.table.dataSize == this.selected
    },
    iminate() {
      return this.selected > 0 && this.table.dataSize > this.selected
    }
  },
  methods: {
    onChange() {
      const check = this.checked || this.iminate
      this.table.toggleAllSelection(!check)
    }
  }
}
